// Import Libraries
// @ts-ignore
require("./bootstrap")

import "jquery"
import "jquery-match-height"
import "css-element-queries/src/ResizeSensor"
import "objectFitPolyfill"
import "popper.js"

import "bootstrap"

import "./Polyfills/polyfill.closest"

import "./Globals/anchorFromUrl"
import "./Globals/smoothScroll"
import "./Globals/referenceLightbox"
import "./Globals/bannerClose"

// @ts-ignore
const ElementQueries = require("css-element-queries/src/ElementQueries")
//attaches to DOMLoadContent
ElementQueries.listen()
//or if you want to trigger it yourself.
// Parse all available CSS and attach ResizeSensor to those elements which have rules attached
// (make sure this is called after 'load' event, because CSS files are not ready when domReady is fired.
ElementQueries.init()
